import {
  agDetailCol,
  agEndDateCol,
  agPriceCol,
  agStartDateCol,
  agStatusCol,
  exchangeRateCol,
  priceChangeCol
} from '@/ag-grid/ag-columns'
import { notAnyPriceCheck, notAnyValueCheck } from '@/ag-grid/utils/notAnyValue'
// Components
import ItemsColumn from './ItemsColumn.vue'

export default {
  computed: {
    gridOptions() {
      return {
        context: {
          sortColumn: 2
        },
        columnDefs: [
          agStatusCol(),

          agStartDateCol({
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          agEndDateCol({
            editable: params => !params.data.one_time_purchase,
            cellClassRules: {
              'editable-cell': params => !params.data.one_time_purchase
            },
            cellEditorFramework: 'DateEditor'
          }),

          agDetailCol({
            hide: false,
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'TextEditor'
          }),

          {
            headerName: 'Purchase order reference',
            field: 'member_purchase_order_reference',
            editable: true,
            headerClass: ['multiple-lines'],
            cellClass: ['editable-cell'],
            cellEditorFramework: 'TextEditor',
            cellRenderer: notAnyValueCheck
          },

          agPriceCol('List Price', 'list_price', {
            hide: true,
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell']
          }),

          agPriceCol('First Offer Price', 'first_offer_price', {
            hide: true,
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell']
          }),

          agPriceCol('Forecasted Price', 'forecasted_price', {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell']
          }),

          agPriceCol('Forecasted Local Price', 'forecasted_local_price', {
            hide: true,
            cellRenderer: params => notAnyPriceCheck(params, 'normalized_currency'),
            maxWidth: 120,
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell']
          }),

          agPriceCol('Final Price', 'price', {
            editable: params => params.data.items_count === 0,
            cellClassRules: {
              'editable-cell': params => params.data.items_count === 0,
              'ag-right-aligned-cell': params => true
            }
          }),

          {
            headerName: 'Currency',
            field: 'currency',
            editable: params => params.data.permissions.currency.edit.allow,
            type: 'rightAligned',
            cellClassRules: {
              'editable-cell': params => params.data.permissions.currency.edit.allow
            },
            cellEditorFramework: 'DropdownEditor',
            cellEditorParams: {
              options: this.currencies,
              emitValue: true
            },
            cellRenderer: notAnyValueCheck
          },

          exchangeRateCol({
            editable: params => params.data.items_count === 0,
            cellClass: [],
            cellClassRules: {
              'editable-cell': params => params.data.items_count === 0,
              'ag-right-aligned-cell': params => true
            }
          }),

          agPriceCol('Price in Local Currency', 'normalized_price', {
            headerClass: ['text-right', 'multiple-lines'],
            cellRenderer: params => notAnyPriceCheck(params, 'normalized_currency'),
            editable: params => params.data.items_count === 0,
            cellClassRules: {
              'editable-cell': params => params.data.items_count === 0,
              'ag-right-aligned-cell': params => true
            }
          }),

          {
            headerName: 'Items',
            type: 'rightAligned',
            cellRendererFramework: ItemsColumn,
            cellRendererParams: {
              onClick: this.showItemsModal
            }
          },

          {
            headerName: 'Vendor',
            field: 'vendor',
            hide: true,
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DropdownEditor',
            cellEditorParams: {
              options: this.vendors,
              optionLabel: 'name',
              optionValue: 'id'
            },
            cellRenderer: params => {
              return params.value?.name || 'N/A'
            }
          },

          {
            headerName: 'Publisher',
            field: 'publisher',
            hide: true,
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DropdownEditor',
            cellEditorParams: {
              options: this.publishers,
              optionLabel: 'name',
              optionValue: 'id'
            },
            cellRenderer: params => {
              return params.value?.name || 'N/A'
            }
          },

          {
            headerName: 'Financial period',
            field: 'financial_period',
            hide: true,
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DropdownEditor',
            cellEditorParams: {
              options: this.financialPeriodOptions,
              emitValue: true
            },
            cellRenderer: params =>
              `${this.formatDateForLocale(params.data.financial_period.start_date)} - ${this.formatDateForLocale(
                params.data.financial_period.end_date
              )}`
          },

          priceChangeCol(),

          {
            headerName: 'Actions',
            cellRendererFramework: 'ActionsCol',
            sortable: false,
            lockVisible: true,
            maxWidth: 100,
            type: 'centerAligned',
            cellRendererParams: params => {
              return {
                popupActions: [
                  {
                    name: 'accept',
                    label: 'Accept'
                  },

                  {
                    name: 'cancel',
                    label: 'Cancel'
                  },

                  {
                    name: 'delete',
                    label: 'Delete',
                    textColorClass: 'text-danger-1'
                  }
                ],

                onPopupAction: event => {
                  if (event === 'delete') this.onDelete(params.data)
                  else if (event === 'itemsModal') this.showItemsModal(params.data)
                  else this.acceptOrCancelClicked(params, event)
                }
              }
            }
          }
        ],
        domLayout: 'autoHeight'
      }
    }
  }
}
